export const actors = {
  CUSTOMER: 'customer',
  PROVIDER: 'provider',
  OPERATOR: 'operator',
  SYSTEM: 'system',
};
